import React from "react";
import COLORS from "../Helpers/colors";

interface MarkerPosition {
    left: string;
    top: string;
    width: string;
    height: string;
}

interface MarkerProps {
    position: MarkerPosition;
    extraTransform?: string;
    /** Drop shadow that lifts the pin off busy photos. */
    shadow?: boolean;
    /** Width of the white ring in px. */
    borderWidth?: number;
}

// A plain red dot with a white ring; callers set its size through position.width/height
const Marker: React.FC<MarkerProps> = ({position, extraTransform, shadow = false, borderWidth = 2}) => {
    return (
        <div
            className="marker"
            style={{
                ...position,
                position: 'absolute',
                backgroundColor: COLORS.locationRed,
                // Inline so the global .marker rule in LevelPage.css (padding: 15px) can't enlarge it
                padding: 0,
                borderRadius: '50%',
                border: `${borderWidth}px solid white`,
                boxShadow: shadow ? 'rgba(0, 0, 0, 1) 0px 0px 10px' : undefined,
                transform: `translate(-50%, -50%)${extraTransform ? ` ${extraTransform}` : ''}`,
                zIndex: 10,
                pointerEvents: 'none',
            }}
        />
    );
};

export default Marker;
